import { Provider } from '@angular/core';
import { CatalogAttributeDefinitionService } from './services/catalog-attribute-definition.service';
import { CatalogAttributeValueService } from './services/catalog-attribute-value.service';
import { CatalogCategoryService } from './services/catalog-category.service';
import { CategoryDuplicateOrchestrationService } from './services/category-duplicate-orchestration.service';
import { CatalogCategoryIconRegistryService } from './services/catalog-category-icon-registry.service';
import { CatalogProductService } from './services/catalog-product.service';
import { CatalogMarketingService } from './services/catalog-marketing.service';
import { ProductFormModifierOrchestrationService } from './services/product-form-modifier-orchestration.service';
import { ProductFormHydrationService } from './services/product-form-hydration.service';
import { ProductFormMutationFeedbackService } from './services/product-form-mutation-feedback.service';
import { ProductFormDraftCoordinatorService } from './services/product-form-draft-coordinator.service';
import { ProductFormMediaService } from './services/product-form-media.service';
import { ProductFormSaveCoordinatorService } from './services/product-form-save-coordinator.service';
import { ProductFormVariantOrchestrationService } from './services/product-form-variant-orchestration.service';
import { AttributeDefinitionFormOrchestrationService } from './services/attribute-definition-form-orchestration.service';
import { ModifierGroupFormOrchestrationService } from './services/modifier-group-form-orchestration.service';
import { AttributeDefinitionApiService } from './data-access/attribute-definition-api.service';
import { AttributeValueApiService } from './data-access/attribute-value-api.service';
import { CategoryApiService } from './data-access/category-api.service';
import { CategoryIconRegistryApiService } from './data-access/category-icon-registry-api.service';
import { ProductApiService } from './data-access/product-api.service';
import { CatalogMarketingApiService } from './data-access/catalog-marketing-api.service';

import { ModifierGroupDefinitionApiService } from './data-access/modifier-group-definition-api.service';
import { ModifierOptionDefinitionApiService } from './data-access/modifier-option-definition-api.service';
import { CatalogModifierGroupDefinitionService } from './services/catalog-modifier-group-definition.service';
import { CatalogModifierOptionDefinitionService } from './services/catalog-modifier-option-definition.service';

export const CATALOG_PROVIDERS: Provider[] = [
  CatalogCategoryService,
  CategoryDuplicateOrchestrationService,
  CatalogCategoryIconRegistryService,
  CatalogProductService,
  CatalogMarketingService,
  ProductFormModifierOrchestrationService,
  ProductFormHydrationService,
  ProductFormMutationFeedbackService,
  ProductFormDraftCoordinatorService,
  ProductFormMediaService,
  ProductFormSaveCoordinatorService,
  ProductFormVariantOrchestrationService,
  AttributeDefinitionFormOrchestrationService,
  ModifierGroupFormOrchestrationService,
  ProductApiService,
  CatalogMarketingApiService,
  CategoryApiService,
  CategoryIconRegistryApiService,
  CatalogAttributeDefinitionService,
  CatalogAttributeValueService,
  AttributeDefinitionApiService,
  AttributeValueApiService,
  CatalogModifierGroupDefinitionService,
  CatalogModifierOptionDefinitionService,
  ModifierGroupDefinitionApiService,
  ModifierOptionDefinitionApiService,
];
